var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.421 3.421L8.49119 7.33328C8.38593 7.54381 8.38593 7.54381 8.14032 7.5789L3.87716 8.19293C2.45611 8.38591 1.87716 10.1578 2.8947 11.1929L5.99997 14.228C6.1754 14.4035 6.1754 14.4035 6.14032 14.6491L5.40347 18.8947C5.15786 20.3333 6.70172 21.4561 7.96488 20.7543L11.7894 18.7368C12 18.6315 12 18.6315 12.2105 18.7368L16.0351 20.7543C17.2982 21.4561 18.8421 20.3333 18.5965 18.8947L17.8596 14.6491C17.8245 14.3859 17.8245 14.3859 18 14.228L21.1052 11.1929C22.1228 10.1578 21.5438 8.38591 20.1228 8.19293L15.8596 7.5789C15.614 7.54381 15.614 7.54381 15.5087 7.33328L13.5789 3.421C12.9122 2.15784 11.0877 2.15784 10.421 3.421Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b3c81bcc.svg";
export { ForwardRef as ReactComponent };